// extracted by mini-css-extract-plugin
export default {"choiceInputs":"ChoiceFieldInput_choiceInputs__52JAq","isColumn":"ChoiceFieldInput_isColumn__Nxohb","isError":"ChoiceFieldInput_isError__AJXe7"};